import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import './styleChartContract.css'
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@fluentui/react';
import i18next from 'i18next';



function ELEMENT_KPI_AMOUNT(props) {
  //Helpers
  const { t } = useTranslation();

  const { 
    inputParam_HideHeader = false,
    inputParam_ComponentContent = null,
    inputParam_UseFake = false,
    inputParam_BoardStructure = null,
    inputParam_Container = null
  } = props;

  const [lCurrencies, setLCurrencies] = useState(!inputParam_UseFake ? inputParam_ComponentContent.items.map(x => ({key: x.measurementUnit, text : x.measurementUnit})) : []);
  const [displayedCurrency, setDisplayedCurrency] = useState(!inputParam_UseFake ? (inputParam_ComponentContent.items.length > 0 ? inputParam_ComponentContent.items[0].measurementUnit : "") : "--");

  const state = {
    series: [
      {
        name: 'Actual',
        type: 'bar',
        data: (!inputParam_UseFake ? inputParam_ComponentContent.items : [])
        .find(x => x.measurementUnit === displayedCurrency) !== undefined ? inputParam_ComponentContent.items
          .find(x => x.measurementUnit === displayedCurrency).vals
          .map(x => ({
            x: x.periodId.toString(),
            y: x.spentValue,
            goals: [
              {
                name: 'Expected',
                value: x.goalValue,
                strokeHeight: 5,
                strokeColor: '#5E7EBB',
              },
            ],
          })
        ) : [],
        color: '#AEBCD9'
      },
      {
        name: 'Tendence',
        type: 'line',
        data: (!inputParam_UseFake ? inputParam_ComponentContent.items : [])
        .find(x => x.measurementUnit === displayedCurrency) !== undefined ? inputParam_ComponentContent.items
          .find(x => x.measurementUnit === displayedCurrency).vals
          .map(x => ({
            x: x.periodId.toString(),
            y: x.trendValue,
          })
        ) : [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'bar',
      },
      title: {
        text: displayedCurrency,
        style: {
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#5E7EBB',
          lineHeight: '30px',
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '60%',
        },
      },
      
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        showForSingleSeries: true,

      },
      xaxis: {
        categories: !inputParam_UseFake ? inputParam_ComponentContent.items.find(x => x.measurementUnit === displayedCurrency) !== undefined ? inputParam_ComponentContent.items.find(x => x.measurementUnit === displayedCurrency).vals.map(x => x.periodId.toString()) : [] : [],
      },
      yaxis: {
        labels: {
          formatter: (value) => {
            return parseFloat(value.toFixed(2)).toLocaleString(i18next.language);
          }
        },
      },
      stroke: {
        width: [0, 2],
        dashArray: [0, 5],
      },
    },
  };

  const renderComponent = () => {
    return  <Row className='h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
              <Col className=''>
                <ReactApexChart options={state.options} series={state.series} type='bar' height='100%' />
              </Col>
            </Row>
  }

  const onChangeDisplayedCurrency = (ev, item) => {
    setDisplayedCurrency(item.key);
  };

  return (
    <>
    {
      !inputParam_UseFake &&
      <Card className='h-100'>
        {!inputParam_HideHeader && (
          <Card.Header className='card-header-compact'>
            <Card.Title className='d-flex justify-content-between'>
              <b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-boxname-contractschart')}</b>
              <div className='toolbar d-flex'>
                <Dropdown
                    placeholder={t('data-lang-placeholder-selectoption')}
                    options={lCurrencies}
                    selectedKey={displayedCurrency}
                    onChange={onChangeDisplayedCurrency}
                    styles={ {dropdown: { width: 100 }, title: { height: "27px" }} }
                    className="pt-1"
                />
                <HEADER_TOOLBAR
                  inputParam_BoardStructure={inputParam_BoardStructure}
                  inputParam_Container={inputParam_Container}
                />
              </div>
            </Card.Title>
          </Card.Header>
        )}
        <Card.Body className='h-100'>
          {renderComponent()}
        </Card.Body>
      </Card>
    }
    {
      inputParam_UseFake && renderComponent()
    }
    </>
  );
}

export default ELEMENT_KPI_AMOUNT;